// extracted by mini-css-extract-plugin
export var menuIcon = "_tn-0";
export var menuIconInline = "_tn-1";